
import React, { Component } from 'react';
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import requisitionStyle from '../../assets/jss/requisitionStyle'
import GridContainer from '../../components/Grid/GridContainer'
import GridItem from '../../components/Grid/GridItem'
import {
  withStyles,
  Stepper,
  Step,
  StepLabel,
  StepConnector,
} from '@material-ui/core';
import '../../assets/css/requisition.css'
import JobInformation from '../requisition/JobInformation'
import PositionInformation from '../requisition/PositionInformation'
import SourcingAndSelection from '../requisition/SourcingAndSelection'
import AdditionalInformation from '../requisition/AdditionalInformation'
import Interviewers from '../requisition/Interviewers'
import {
  submitRequisition
} from '../../actions/RequisitionActions'
import * as Sentry from '@sentry/browser'

Sentry.init({
  dsn: "https://8b7fd3762e754bab8c1c1e62dd17f0db@sentry.io/1388765"
});

class Requisition extends Component {

  constructor() {
    super();
    this.state = {
      activeStep: 0
    }
  }

  componentDidCatch(error, errorInfo) {
    Sentry.withScope(scope => {
      Object.keys(errorInfo).forEach(key => {
        scope.setExtra(key, errorInfo[key]);
      });
      Sentry.captureException(error);
    });
  }

  handleNext = () => {
    this.setState(state => ({
      activeStep: state.activeStep + 1
    })
    )
  }

  handleBack = () => {
    this.setState(state => ({
      activeStep: state.activeStep - 1
    })
    )
  }

  handleReset = () => {
    this.setState({
      activeStep: 0
    })
  }

  render() {

    const { classes } = this.props
    const { activeStep } = this.state
    const steps = getSteps()
    const connector = this.stepConnector()

    return (
      <div>
        <div className={classes.main}>

          <h4 className="Employee-Requisition-Form">
            Employee Requisition Form
          </h4>

          <div className="Content">

            <Stepper
              className={classes.stepper}
              color="secondary"
              activeStep={activeStep}
              connector={connector}
            >
              {
                steps.map((index, key) => (
                  <Step key={key} className={classes.step}>
                    <StepLabel
                      StepIconProps={
                        {
                          classes: {
                            active: classes.active
                          }
                        }
                      }
                    >{index}</StepLabel>
                  </Step>
                ))
              }
            </Stepper>


            <GridContainer>
              <GridItem xs={12} sm={12} md={12}>
                <div className="Stepper-Content-Holder">
                  {
                    this.getStepContent(activeStep)
                  }
                </div>
              </GridItem>
            </GridContainer>


          </div>
        </div>

      </div>
    );
  }

  onSubmitRequisition = () => {

    const { form, requisition } = this.props.requisition_data

    this.props.submitRequisition({ form, requisition })

  }

  stepConnector = () => {

    const { classes } = this.props;

    return (
      <StepConnector
        classes={{
          active: classes.connectorActive,
          completed: classes.connectorCompleted,
          disabled: classes.connectorDisabled,
          line: classes.connectorLine,
        }}
      />
    )
  }



  getStepContent(index) {

    switch (index) {
      case 0:
        return <PositionInformation next={this.handleNext} />
      case 1:
        return <JobInformation next={this.handleNext} back={this.handleBack} />
      case 2:
        return <SourcingAndSelection next={this.handleNext} back={this.handleBack} />
      case 3:
        return <AdditionalInformation next={this.handleNext} back={this.handleBack} />
      case 4:
        return <Interviewers
          submitRequisition={this.onSubmitRequisition}
          back={this.handleBack}
          reset={this.handleReset} />
      default:
        return null
    }
  }
}

function getSteps() {
  return ["Position Information", "Job Information", "Sourcing And Selection", "Additional Info", "List of Interviewers"]
}

Requisition.propTypes = {
  classes: PropTypes.object.isRequired
}

const mapDispatchToProps = (dispatch, props) => ({
  submitRequisition: (data) => {
    dispatch(
      submitRequisition(data)
    )
  }
})

const mapStateToProps = state => ({
  requisition_data: state
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(requisitionStyle)(Requisition));
